import { z } from "zod";
import { AccountType } from "../../constants/domains/accounting/accounts";
import { accountSubtypeSchema } from "../../schemas/domains/accounting/account.schema";

export const SuggestedAccountMappingSchema = z.object({
    name: z.string(),
    suggested_type: z.nativeEnum(AccountType).nullable(),
    suggested_subtype: accountSubtypeSchema.nullable(),
    suggested_account_id: z.string().nullable(),
});

export const CoAAccountMappingSuggestionsSchema = z.object({
    mappings: z.array(SuggestedAccountMappingSchema),
    warnings: z.array(z.string()),
});

export type SuggestedAccountMapping = z.infer<
    typeof SuggestedAccountMappingSchema
>;
export type CoAAccountMappingSuggestions = z.infer<
    typeof CoAAccountMappingSuggestionsSchema
>;
